var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pre-register"},[_c('Header'),_c('div',{staticClass:"main-content"},[_c('h1',{staticClass:"main-heading"},[_vm._v("管理者仮登録")]),_c('PreRegisterForm')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }